import { render, staticRenderFns } from "./DeliveryProcess.vue?vue&type=template&id=ddf72214&scoped=true&"
import script from "./DeliveryProcess.vue?vue&type=script&lang=js&"
export * from "./DeliveryProcess.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryProcess.vue?vue&type=style&index=0&id=ddf72214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf72214",
  null
  
)

export default component.exports